// extracted by mini-css-extract-plugin
export default {"dots":"loading-dots_dots__ivQYL","dot":"loading-dots_dot__GCxWi","dot-blink":"loading-dots_dot-blink__Kfmkn"};